class ambitsServices {
    constructor($resource,SERVICE_URL_CONSTANT) {
		const services = $resource(SERVICE_URL_CONSTANT.adminPanel +'/ambits/:route',{},{
			getAmbits:{
				method:'GET',
				params : {}
			},
			getCoresbyUserStudent:{
				method:'GET',
				params : {
					route: 'cores-by-user'
				}
			},
			getCoresbyUserStudentDownload:{
				method:'GET',
				params : {
					route: 'cores-by-user-download'
				}
			},
			getAmbitDetails:{
				method:'GET',
				params : {
					route: 'id'
				}
			},
			saveAmbits:{
				method:'POST',
				params : {}
			},
			updateAmbits:{
				method:'PUT',
				params : {}
			},

		});

		return {
			services : services
		};
	}
}

ambitsServices.$inject=['$resource','SERVICE_URL_CONSTANT']

export default  angular.module('services.ambitsServices', [])
.service('ambitsServices', ambitsServices)
.name;



// WEBPACK FOOTER //
// ./src/app/admin-panel/ambits/ambitsServices.js